export const comingSoonModalTranslations = {
  "en-US": {
    title: "Coming Soon",
    message:
      "This feature will be available soon. If you have any questions or need help, please contact us",
  },
};

export default comingSoonModalTranslations;
